// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__2Upla","tab":"Tabs_tab__1tt1V","tabActive":"Tabs_tabActive__Bt5q5"};